var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fund-detail"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require(("@/assets/icons/" + _vm.icon + ".svg"))}})]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }